// The calendar's day keys are YYYY-MM-DD strings. Calendar days are built as
// LOCAL midnight (`new Date('2026-10-13T00:00:00')`, no Z), so the date a
// person sees is the local one, and the key for a day must be read with the
// local getters too.
//
// `toISOString()` is the trap: it gives the UTC date. For a day object at
// local midnight that happens to agree anywhere west of Greenwich, which is
// why the keys looked right. For "now" it does not: at 8pm Eastern it is
// already tomorrow in UTC, and the phone calendar homed onto the next day
// every evening, skipping past that night's 9pm screening.

const pad = (n) => String(n).padStart(2, '0');

// The YYYY-MM-DD key of a Date, by the local calendar.
export const localDateKey = (date) =>
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

// Today's key, by the clock on the device.
export const todayKey = () => localDateKey(new Date());
